module.exports = "<button [disabled]=\"isBtnDisabled\" type=\"button\" class=\"btn btn-default btn-lg\" (click)=\"copyToQuickbooks(invoiceData.id)\">\n    <i class=\"fi fa fa-files-o\"></i>Copy to Quickbooks\n</button>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/copy-to-qb-btn/copy-to-qb-btn.html
// module id = ./web/modern/components/buttons/copy-to-qb-btn/copy-to-qb-btn.html
// module chunks = 0